/**
 * Utility functions for fact-checking feature
 */

/**
 * Truncate a URL to a readable length
 */
export const truncateUrl = (url: string, maxLength: number = 60): string => {
  try {
    // Strip everything after the first # (fragments)
    const urlWithoutFragment = url.split("#")[0]

    // Try to decode the URL
    const decoded = decodeURIComponent(urlWithoutFragment)
    if (decoded.length <= maxLength) return decoded

    const urlObj = new URL(urlWithoutFragment)
    const domain = urlObj.hostname
    const path = urlObj.pathname + urlObj.search

    // Decode the URL components
    const decodedPath = decodeURIComponent(path)

    if (decodedPath.length > maxLength - domain.length - 5) {
      const pathParts = decodedPath.split("/")
      if (pathParts.length > 2) {
        const firstPart = pathParts[1] || ""
        const lastPart = pathParts[pathParts.length - 1] || ""
        return `${domain}/${firstPart}/.../${lastPart}`
      }
    }

    const fullDecoded = `${domain}${decodedPath}`
    return fullDecoded.length > maxLength
      ? fullDecoded.slice(0, maxLength - 3) + "..."
      : fullDecoded
  } catch {
    try {
      // Strip fragment in fallback too
      const urlWithoutFragment = url.split("#")[0]
      const decoded = decodeURIComponent(urlWithoutFragment)
      return decoded.length > maxLength ? decoded.slice(0, maxLength - 3) + "..." : decoded
    } catch {
      const urlWithoutFragment = url.split("#")[0]
      return urlWithoutFragment.length > maxLength
        ? urlWithoutFragment.slice(0, maxLength - 3) + "..."
        : urlWithoutFragment
    }
  }
}

/**
 * Get confidence color class based on score
 */
export const getConfidenceColor = (confidence: number): string => {
  if (confidence >= 80) return "text-success"
  if (confidence >= 60) return "text-warning"
  if (confidence >= 40) return "text-primary-ink "
  return "text-destructive"
}

/**
 * Get traffic light background color based on confidence
 */
export const getTrafficLightColor = (confidence: number): string => {
  if (confidence >= 80) return "bg-success"
  if (confidence >= 50) return "bg-warning"
  return "bg-destructive"
}
